import { render, staticRenderFns } from "./rightsupport.vue?vue&type=template&id=53b86e62&scoped=true&"
import script from "./rightsupport.vue?vue&type=script&lang=js&"
export * from "./rightsupport.vue?vue&type=script&lang=js&"
import style0 from "./rightsupport.vue?vue&type=style&index=0&id=53b86e62&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53b86e62",
  null
  
)

export default component.exports